/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskStatus } from './ExecRiskStatus';
import {
    ExecRiskStatusFromJSON,
    ExecRiskStatusFromJSONTyped,
    ExecRiskStatusToJSON,
} from './ExecRiskStatus';

/**
 * 
 * @export
 * @interface ExecRiskScanStatus
 */
export interface ExecRiskScanStatus {
    /**
     * 
     * @type {ExecRiskStatus}
     * @memberof ExecRiskScanStatus
     */
    form990?: ExecRiskStatus;
    /**
     * 
     * @type {ExecRiskStatus}
     * @memberof ExecRiskScanStatus
     */
    form5500?: ExecRiskStatus;
}

/**
 * Check if a given object implements the ExecRiskScanStatus interface.
 */
export function instanceOfExecRiskScanStatus(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskScanStatusFromJSON(json: any): ExecRiskScanStatus {
    return ExecRiskScanStatusFromJSONTyped(json, false);
}

export function ExecRiskScanStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskScanStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form990': !exists(json, 'form990') ? undefined : ExecRiskStatusFromJSON(json['form990']),
        'form5500': !exists(json, 'form5500') ? undefined : ExecRiskStatusFromJSON(json['form5500']),
    };
}

export function ExecRiskScanStatusToJSON(value?: ExecRiskScanStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form990': ExecRiskStatusToJSON(value.form990),
        'form5500': ExecRiskStatusToJSON(value.form5500),
    };
}

